<template>
  <div
    class="toggle-switch"
    :class="{ disabled: readonly }"
    :style="{ border: `1px solid ${value ? onColor : offColor}` }"
    @click="toggle"
  >
    <div class="toggle-text-left" :style="textStyles">OFF</div>
    <div class="toggle-text-right" :style="textStyles">ON</div>
    <md-button
      class="pill"
      :disabled="readonly"
      :class="{ 'pill-left': !value, 'pill-right': value }"
      :style="{ backgroundColor: `${value ? onColor : offColor }` }"
    >
      {{ readonly ? '' : value ? 'ON' : 'OFF' }}
    </md-button>
  </div>
</template>

<script>
export default {
  name: 'toggle-switch',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    readonly: {
      type: Boolean,
      default: false
    },
    onColor: {
      type: String,
      default: '#0C70B0'
    },
    offColor: {
      type: String,
      default: '#0C70B0'
    }
  },
  computed: {
    textStyles() {
      return {
        zIndex: this.readonly ? 1 : 0,
        color: this.readonly ? '#d2d2d2' : '#2b2b2b',
      };
    },
  },
  methods: {
    toggle() {
      if (this.readonly) {
        return;
      }
      this.$emit('toggle', !this.value);
    }
  }
}
</script>

<style scoped>
.toggle-switch {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100px;
  height: 40px;
  border: 1px solid #0C70B0;
  border-radius: 50px;
  font-size: 14px;
  font-weight: 500;
  user-select: none;
  position: relative;
  cursor: pointer;
}

.toggle-switch.disabled {
  color: rgba(0,0,0,0.26);
  border-color: rgba(0,0,0,0.26);
  cursor: default;
}

.toggle-switch:not(:last-child) {
  margin-right: 8px;
  margin-bottom: 8px;
}

.toggle-switch .md-button {
  margin: 0;
}

.toggle-text {
  color: #d2d2d2;
}

.toggle-text-left {
  margin-left: 12px;
}

.toggle-text-right {
  margin-right: 16px;
}

.pill {
  min-width: 54px;
  height: 40px;
  border-radius: 50px;
  color: white;
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: transform .25s;
}

.pill-right {
  transform: translateX(44px);
}
</style>